import gql from 'graphql-tag';

export const GET_DROPDOWN_INFORMATION_AMSA = gql`
  query GET_DROPDOWN_INFORMATION_AMSA {
    segmentos: mdm_collahuasi_types(where: {combo_objeto: {_eq: "Amsa.Segmento"}}) {
      id
      code: taxonomy_id
      name
      parent_taxonomy_id
    }
    FeaturePlanningNeeds: mdm_collahuasi_types(where: {combo_objeto: {_eq: "Amsa.FeaturePlanningNeeds"}}) {
      id
      code
      name
    }
    MaterialCarryingGroup: mdm_collahuasi_types(where: {combo_objeto: {_eq: "Amsa.MaterialCarryingGroup"}}) {
      id
      code
      name
    }
    ArticlesGroup: mdm_collahuasi_types(where: {combo_objeto: {_eq: "Amsa.ArticlesGroup"}}) {
      id
      code
      name
    }
    MeasureBaseUnit: mdm_collahuasi_types(where: {combo_objeto: {_eq: "Amsa.MeasureBaseUnit"}}) {
      id
      code
      name
    }
    FrequencyChange: mdm_collahuasi_types(where: {combo_objeto: {_eq: "Amsa.FrequencyChange"}}, order_by: {id: asc}) {
      id
      code
      name
    }
    PurchaseGroup: mdm_collahuasi_types(where: {combo_objeto: {_eq: "Amsa.PurchaseGroup"}}) {
      id
      code
      name
      parent_code
    }
    Warehouse: mdm_collahuasi_types(where: {combo_objeto: {_eq: "Amsa.Warehouse"}}) {
      id
      code
      name
      parent_code
    }
    LogisticsCenter: mdm_collahuasi_types(where: {combo_objeto: {_eq: "Amsa.LogisticsCenter"}}) {
      id
      code
      name
    }
    RatingCategory: mdm_collahuasi_types(where: {combo_objeto: {_eq: "Amsa.RatingCategory"}}) {
      id
      code
      name
      parent_code
    }
    MaterialType: mdm_collahuasi_types(where: {combo_objeto: {_eq: "Amsa.MaterialType"}}) {
      id
      code
      name
    }
    idmAMSA: mdm_collahuasi_types(where: {combo_objeto: {_eq: "Amsa.IdmAmsa"}}) {
      id
      code
      name
    }
  }
`;

export const GET_MANUFACTURER = gql`
query GET_MANUFACTURER($name: String = "") {
  SAPCodeManufacture: mdm_collahuasi_types(where: {combo_objeto: {_eq: "Amsa.SAPCodeManufacture"}, name: {_ilike: $name}}) {
    id
    code
    name
    short_name
  }
}
`;

export const GET_FAMILY_AMSA = gql`
  query GET_FAMILY_AMSA($parent_taxonomy_id: String) {
    familia: mdm_collahuasi_types(where: {combo_objeto: {_eq: "Amsa.Familia"}, parent_taxonomy_id: {_eq: $parent_taxonomy_id}}) {
      id
      code: taxonomy_id
      name
      parent_taxonomy_id
    }
  }
`;

export const GET_CLASE_AMSA = gql`
query GET_CLASE_AMSA($parent_taxonomy_id: String) {
  clase: mdm_collahuasi_types(where: {combo_objeto: {_eq: "Amsa.Clase"}, parent_taxonomy_id: {_eq: $parent_taxonomy_id}}) {
    id
    code: taxonomy_id
    name
    parent_taxonomy_id
  }
}
`;

export const GET_TEMPLATE_AMSA = gql`
query GET_TEMPLATE_AMSA($parent_taxonomy_id: String) {
  template: mdm_collahuasi_types(where: {parent_taxonomy_id: {_eq: $parent_taxonomy_id}}) {
    id
    code
    description
    name
  }
}
`;

export const GET_AMSA_MATERIALS = gql`
query GET_AMSA_MATERIALS {
  getAllAMSAMaterials: mdm_amsa_material_creation(order_by: {created_at: desc}) {
    anual_consumption_frequency_id
    articles_group_id
    availability_verification
    base_quantity
    base_uom_id
    batch_size_needs_planning
    clase
    comment
    created_at
    creation_user
    description
    epp_material
    expected_delivery_time_in_days
    external_provisioning_storage
    familia
    fixed_planning
    folio
    hazardous_substance_material
    hers_code
    horizon_key
    id
    idm_amsa
    izaje_material
    last_action
    lead_time
    load_group
    logistic_center_id
    manufacturer_abbreviation
    manufacturer_id
    manufacturer_name
    material_handling_group_id
    material_type_id
    needs_planner
    part_number
    period_indicator
    planning_group
    planning_needs_id
    predicted_useful_life_in_months
    price_control_indicator
    processing_time
    provisioning_class
    purchasing_group_id
    ramo
    rating_type
    rating_category_id
    reference_stock
    rejection_comment
    sap_manufacturer_code
    sap_material_number
    sap_short_description
    search_statistic
    sector
    segmento
    short_text
    stage_id
    step_id
    subject_batch
    template
    transport_group
    updated_at
    urgency
    usd_reference_price
    used_quantity
    validity_end_date
    validity_start_date
    warehouse_id
    weight_uom
    userByCreationUser {
      id
      user_name
    }
    request_description
    workflow_step {
      id
      name
      workflowId
    }
  }
}
`;

export const GET_AMSA_MATERIAL_BY_ID = gql`
query GET_AMSA_MATERIAL_BY_ID($id: Int!) {
  amsaMaterialById: mdm_amsa_material_creation_by_pk(id: $id) {
    anual_consumption_frequency_id
    articles_group_id
    availability_verification
    base_quantity
    base_uom_id
    batch_size_needs_planning
    clase
    comment
    created_at
    creation_user
    description
    epp_material
    expected_delivery_time_in_days
    external_provisioning_storage
    familia
    fixed_planning
    folio
    hazardous_substance_material
    hers_code
    horizon_key
    id
    idm_amsa
    izaje_material
    last_action
    lead_time
    load_group
    logistic_center_id
    manufacturer_abbreviation
    manufacturer_id
    manufacturer_name
    material_handling_group_id
    material_type_id
    needs_planner
    part_number
    period_indicator
    planning_group
    planning_needs_id
    predicted_useful_life_in_months
    price_control_indicator
    processing_time
    provisioning_class
    purchasing_group_id
    ramo
    rating_type
    rating_category_id
    reference_stock
    rejection_comment
    sap_manufacturer_code
    sap_material_number
    sap_short_description
    search_statistic
    sector
    segmento
    short_text
    stage_id
    step_id
    subject_batch
    template
    transport_group
    updated_at
    urgency
    usd_reference_price
    used_quantity
    validity_end_date
    validity_start_date
    warehouse_id
    weight_uom
    userByCreationUser {
      id
      user_name
    }
    request_description
    workflow_step {
      id
      stepApproval
      stepReject
      name
      stepOrder
    }
  }
  logs: mdm_amsa_step_log(where: {material_creation_id: {_eq: $id}}, order_by: {id: asc}) {
    actionDate: action_date
    actualStep: actual_step
    beforeStep: before_step
    comment: comment
    endAction: end_action
    id
    user {
      id
      user_name
    }
    workflow_action {
      id
      description
    }
  }
}
`;



// WEBPACK FOOTER //
// ./src/store/graphql/queries/amsaCataloger.js